export default "__VITE_ASSET__CgWqwbh1__"